import React, { useEffect } from "react";
import { useRouter } from "next/router";

/**
 * 兼容旧路径 /proptrading/arena/newbie → 统一动态详情页 ROOKIE
 */
const ProptradingArenaNewbieRedirect: React.FC = () => {
  const router = useRouter();

  useEffect(() => {
    router.replace("/proptrading/arena/ROOKIE");
  }, [router]);

  return null;
};

export default ProptradingArenaNewbieRedirect;
